
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Resortnearwashimforfamily() {



  const cardData =
  {
    keyword: ' Resorts Near Washim for Family',
    heading:  'Woodland Escape: Resorts Near Washim for Family ',
    headingDescription: 'Woodland Escape Resort is a wonderful family resort near Washim, offering a serene retreat for all generations to enjoy together. Nestled amidst lush greenery with spacious lawns for children to roam, shady trees for leisurely rests, and cottages designed for family comfort, it’s perfect for parents, kids and elders alike. Guests can indulge in nature walks, calming outdoor spaces, and home-style meals in a peaceful setting. With warm hospitality, safe play areas, and comfortable accommodations, Woodland Escape Resort near Washim ensures that every family stays relaxed, connected and creates beautiful memories away from the city bustle.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Resorts Near Washim for Family",
      "description": "Discover the best family-friendly resorts near Washim that provide a perfect blend of comfort, recreation, and nature. These resorts cater to families of all sizes and ages, offering relaxing stays, kid-friendly amenities, and easy access to local attractions for a memorable vacation experience."
    },
    {
      "name": "Washim Family Resort Stay",
      "description": "Plan a delightful family resort stay in Washim, where every member can enjoy spacious accommodations, recreational activities, and facilities tailored for families. From serene gardens to play areas for children, these resorts are designed to create a safe and enjoyable environment for all."
    },
    {
      "name": "Affordable Family Resorts Washim",
      "description": "Experience budget-friendly family resorts in Washim that don’t compromise on comfort or amenities. These resorts offer well-maintained rooms, delicious meals, and entertainment options suitable for children and adults, making them ideal for families traveling on a budget."
    },
    {
      "name": "Washim Weekend Family Resort",
      "description": "Make your weekends special with a family resort stay in Washim. Enjoy leisure activities, picnic spots, swimming pools, and nature walks that provide a perfect break from the hustle of daily life, ensuring fun and relaxation for everyone."
    },
    {
      "name": "Washim Kids Friendly Resort",
      "description": "Choose a kids-friendly resort in Washim designed with children’s safety and enjoyment in mind. With play areas, adventure zones, and engaging activities, these resorts provide endless entertainment for young guests while parents relax and unwind."
    },
    {
      "name": "Washim Family Outing Resort",
      "description": "Plan a family outing at a resort in Washim that offers outdoor games, group activities, and scenic surroundings. Perfect for bonding experiences, these resorts combine leisure, adventure, and comfort to make every family trip memorable."
    },
    {
      "name": "Washim Nature Resort for Families",
      "description": "Reconnect with nature at family resorts in Washim surrounded by lush greenery, rivers, and hills. These resorts provide eco-friendly accommodations, nature trails, and outdoor activities suitable for all ages, offering a peaceful retreat for nature-loving families."
    },
    {
      "name": "Washim Riverside Family Resort",
      "description": "Enjoy a riverside family resort in Washim offering stunning water views, tranquil surroundings, and outdoor recreational opportunities. Perfect for picnics, boat rides, and leisure walks, these resorts combine relaxation with scenic beauty for a unique family getaway."
    },
    {
      "name": "Washim Hill Resort for Family",
      "description": "Take a family trip to a hill resort near Washim with panoramic views, cool weather, and adventure activities. Ideal for trekking, nature walks, and photography, these resorts offer a refreshing escape for families seeking both relaxation and outdoor fun."
    },
    {
      "name": "Washim Family Picnic Resort",
      "description": "Plan a family picnic at a resort in Washim equipped with spacious lawns, picnic spots, and recreational facilities. These resorts provide a perfect setting for bonding over games, meals, and outdoor fun while enjoying the natural beauty around."
    },
    {
      "name": "Washim Outdoor Family Resort",
      "description": "Choose an outdoor-focused family resort in Washim that offers adventure activities like trekking, cycling, obstacle courses, and open-air events. These resorts are designed to keep families active, entertained, and engaged in the fresh outdoors."
    },
    {
      "name": "Washim Group Family Resort",
      "description": "Ideal for extended families or group outings, these resorts in Washim offer large accommodations, communal spaces, and group activities. Enjoy a vacation together with shared meals, games, and recreational experiences that cater to all ages."
    },
    {
      "name": "Washim Family Resort Booking",
      "description": "Easily book your preferred family resort in Washim online with flexible options, secure payment, and guaranteed availability. Booking in advance ensures a hassle-free experience and allows you to plan your family vacation with peace of mind."
    },
    {
      "name": "Washim One Day Family Resort",
      "description": "Plan a one-day family resort outing in Washim with activities, meals, and sightseeing included. Perfect for day trips, these resorts provide a complete experience of fun, relaxation, and family bonding without needing an overnight stay."
    },
    {
      "name": "Washim Luxury Family Resort",
      "description": "Indulge in a luxurious family resort in Washim offering premium accommodations, spa facilities, gourmet dining, and exclusive recreational activities. Ideal for families seeking comfort, elegance, and a high-end vacation experience in a beautiful setting."
    }
  ],
  "tableData": [
    ["- Resorts Near Washim for Family", "- Washim Family Resort Stay"],
    ["- Affordable Family Resorts Washim", "- Washim Weekend Family Resort"],
    ["- Washim Kids Friendly Resort", "- Washim Family Outing Resort"],
    ["- Washim Nature Resort for Families", "- Washim Riverside Family Resort"],
    ["- Washim Hill Resort for Family", "- Washim Family Picnic Resort"],
    ["- Washim Outdoor Family Resort", "- Washim Group Family Resort"],
    ["- Washim Family Resort Booking", "- Washim One Day Family Resort"],
    ["- Washim Luxury Family Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Best Family Resort Near Washim",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal getaway for families near Washim. Surrounded by lush greenery and calm nature, it offers a safe and enjoyable environment for families to relax and bond."
  },
  {
    "WhyChooseheading": "Peaceful & Natural Surroundings",
    "WhyChoosedescription": "Nestled amidst forest‑like and open green spaces, the resort provides a refreshing atmosphere. Families can enjoy fresh air, nature’s sounds, and quality time away from city noise."
  },
  {
    "WhyChooseheading": "Spacious & Comfortable Accommodation",
    "WhyChoosedescription": "The resort features well‑designed rooms or cottages suitable for family stays. With modern amenities and ample space, it ensures a comfortable and pleasant stay for guests of all ages."
  },
  {
    "WhyChooseheading": "Activities for All Ages",
    "WhyChoosedescription": "Woodland Escape Resort offers a variety of family‑friendly activities such as nature walks, cycling, outdoor games and pond‑side relaxation — making it fun for children and adults alike."
  },
  {
    "WhyChooseheading": "Weekend or Short Stay Friendly",
    "WhyChoosedescription": "Whether you’re planning a full weekend escape or a short overnight stay, the resort is perfect for families looking to unwind, have fun, and create memorable moments together."
  },
  {
    "WhyChooseheading": "Delicious Food & Dining Options",
    "WhyChoosedescription": "Families can enjoy freshly prepared local meals, snacks, and beverages on‑site. The resort ensures that your stay is as tasty as it is relaxing."
  },
  {
    "WhyChooseheading": "Convenient Location from Washim",
    "WhyChoosedescription": "Located within easy reach of Washim, Woodland Escape Resort is convenient for families wanting a nature‑break without long travel times — making it practical for a weekend retreat."
  }
]






















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a family resort near Washim?",
    answer: "Woodland Escape Resort is an ideal family resort near Washim, offering a safe, green and serene environment. Families can enjoy quality time together with open lawns, kids’ play zones, outdoor activities and comfortable stay‑options."
  },
  {
    question: "How far is Woodland Escape Resort from Washim city?",
    answer: "The resort is conveniently located within driving distance from Washim, making it perfect for a family day trip or a weekend stay. It’s easily accessible while still giving a peaceful getaway feel."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for families?",
    answer: "The resort features spacious lawns, dedicated play areas for children, outdoor games, nature walk spots, and family‑friendly accommodations. It’s designed so that both children and adults can enjoy and relax."
  },
  {
    question: "Is Woodland Escape Resort suitable for families with children and older guests?",
    answer: "Absolutely! Woodland Escape Resort is family‑friendly — safe surroundings, open spaces, and amenities are ideal for kids, parents and grandparents alike. Everyone has something to enjoy."
  },
  {
    question: "Does Woodland Escape Resort provide meals and refreshments for families?",
    answer: "Yes! Woodland Escape Resort offers freshly prepared meals, snacks and beverages. Family packages can include lunch, refreshments and sometimes dinner, making your stay comfortable and hassle‑free."
  },
  {
    question: "How can we book our family stay or outing at Woodland Escape Resort near Washim?",
    answer: "Booking is simple — you can call or send a WhatsApp message to our reservations team, or visit the official website. It is recommended to book in advance, especially for weekends and holidays, to secure your preferred dates and room type."
  }
];

const testimonials = [
  {
    name: "Mr. Rohit & Family, Washim",
    text: "Our family stay at Woodland Escape Resort was amazing! The surroundings are peaceful, the kids enjoyed the play area and open space, and the food was excellent. Truly one of the best family resorts near Washim."
  },
  {
    name: "Ms. Anjali & Family, Washim",
    text: "Woodland Escape Resort is perfect for a family getaway. The green lawns, fun activities for kids, and relaxing environment made our weekend memorable. Highly recommended for families near Washim!"
  }
];





























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Resorts Near Washim for Family",
  "image": "https://woodlandescape.com/assets/images/washim-family-resort.jpg",
  "description": "Enjoy a perfect family stay at Woodlandescape Resort near Washim. Ideal for weekend getaways, kids-friendly activities, nature experiences, riverside stays, and hilltop retreats.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "42"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-resorts-washim"
  }
};


  return (
    <div>
<Helmet>
  <title>Resorts Near Washim for Family | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a family getaway at Woodlandescape Resort near Washim. Perfect for weekend stays, kids-friendly fun, nature retreats, riverside relaxation, and hilltop adventures." 
  />
  <meta 
    name="keywords" 
    content="Resorts Near Washim for Family, Washim Family Resort Stay, Affordable Family Resorts Washim, Washim Weekend Family Resort, Washim Kids Friendly Resort, Washim Family Outing Resort, Washim Nature Resort for Families, Washim Riverside Family Resort, Washim Hill Resort for Family, Washim Family Picnic Resort, Washim Outdoor Family Resort, Washim Group Family Resort, Washim Family Resort Booking, Washim One Day Family Resort, Washim Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/42.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Resortnearwashimforfamily;